import * as React from "react";
const SvgVectorline = (props) => /* @__PURE__ */ React.createElement("svg", { width: 1338, height: 2, viewBox: "0 0 1338 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 1H1338", stroke: "#9C765B", strokeWidth: 2, strokeDasharray: "4 4" }));
export default SvgVectorline;
